import { combineReducers } from '@reduxjs/toolkit';

import { jobsSlice } from 'src/store/slices/jobs';
import { metricsSlice } from 'src/store/slices/metrics';
import { infoSlice } from 'src/store/slices/info';
import { userSlice } from 'src/store/slices/users';
import { fileSpecSlice } from 'src/store/slices/fileSpec';
import { jobSpecSlice } from '../slices/jobSpec';
import { filesSlice } from '../slices/files';
import { entitlementsSlice } from '../slices/authUser';
import { menuSlice } from '../slices/menus';

export const combinedReducer = combineReducers({
  jobs: jobsSlice.reducer,
  metrics: metricsSlice.reducer,
  info: infoSlice.reducer,
  users: userSlice.reducer,
  fileSpec: fileSpecSlice.reducer,
  jobSpec: jobSpecSlice.reducer,
  files: filesSlice.reducer,
  entitlements: entitlementsSlice.reducer,
  menu: menuSlice.reducer,
});
